import { Box, Button, Typography } from "@mui/material";
import CustomDialog from "./CustomDialog";
import { ReactComponent as AlertIcon } from "../../assets/icons/alert-red.svg";
import { LoadingButton } from "@mui/lab";

export function ActionModal(props) {
  const {
    open,
    setOpen,
    icon = AlertIcon,
    title,
    description,
    isContained = true,
    actionTitle,
    action,
    cancelTitle,
    loading,
    cancelAction = () => {
      setOpen(false);
    },
  } = props;
  const Icon = icon;

  return (
    <CustomDialog open={open}>
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Icon width={24} height={24} />
          <Typography variant="h4" color="grey.2" ml={1}>
            {title}
          </Typography>
        </Box>
        <Typography
          component={"div"}
          flex={1}
          mt={1}
          variant="body2"
          color="grey.4"
        >
          {description}
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          {cancelTitle && (
            <Button
              onClick={cancelAction}
              variant="text"
              size="small"
              sx={{
                color: "grey.4",
              }}
            >
              {cancelTitle}
            </Button>
          )}
          <LoadingButton
            onClick={action}
            loading={loading}
            variant={isContained ? "contained" : "outlined"}
            color={isContained ? "primary" : "error"}
            size="small"
            sx={{
              color: isContained && "common.white",
              typography: "h5",
              minWidth: 90,
            }}
          >
            {actionTitle}
          </LoadingButton>
        </Box>
      </Box>
    </CustomDialog>
  );
}
